import { render } from "./Qualifications.vue?vue&type=template&id=4cf57a6e"
import script from "./Qualifications.vue?vue&type=script&lang=js"
export * from "./Qualifications.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bilimcert/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__